import { createContext, useContext, useState, useEffect } from 'react';

// Translations
const translations = {
  fr: {
    // Navigation
    nav: {
      home: 'Accueil',
      pricing: 'Tarifs',
      login: 'Connexion',
      register: 'Créer un compte',
      dashboard: 'Tableau de bord',
      invoices: 'Factures',
      quotes: 'Devis',
      clients: 'Clients',
      products: 'Produits/Services',
      projects: 'Projets',
      expenses: 'Dépenses',
      revenues: 'Recettes',
      fiscal: 'Bilan Fiscal',
      team: 'Équipe',
      settings: 'Paramètres',
      logout: 'Déconnexion',
      search: 'Rechercher...',
      recurring: 'Récurrences',
      shopify: 'Shopify',
      reminders: 'Rappels',
      help: 'Aide & FAQ',
      support: 'Support',
      adminTickets: 'Tickets',
      admin: 'Administration',
      employees: 'Employés',
      payslips: 'Fiches de paie',
      absences: 'Planning',
      accounting: 'Comptabilité',
      hrDashboard: 'Dashboard RH',
    },
    // Landing page
    landing: {
      heroTitle: 'Gérez.',
      heroTitleHighlight: 'Simplement.',
      heroSubtitle: 'ERP Suisse tout-en-un : facturation, RH, paie, comptabilité. Conçu pour les indépendants et PME.',
      cta: 'Commencer gratuitement',
      watchDemo: 'Voir la démo',
      trustedBy: 'Ils nous font confiance',
      features: 'Fonctionnalités',
      featuresTitle: 'Tout ce dont vous avez besoin',
      featuresSubtitle: 'Un outil complet pour gérer votre facturation, de A à Z.',
      newFeatures: 'Nouvelles fonctionnalités 2026',
      newFeaturesTitle: 'La facturation',
      newFeaturesTitleHighlight: 'nouvelle génération',
      newFeaturesSubtitle: 'Des outils puissants pour automatiser votre comptabilité et gagner du temps précieux.',
      discoverFree: 'Découvrir gratuitement',
      howItWorks: 'Comment ça marche',
      threeSteps: '3 étapes. C\'est tout.',
      step1Title: 'Créez votre compte',
      step1Desc: 'Inscription en 30 secondes. Sans carte bancaire.',
      step2Title: 'Ajoutez vos clients',
      step2Desc: 'Importez ou créez vos fiches clients en un clic.',
      step3Title: 'Facturez !',
      step3Desc: 'Sélectionnez, remplissez, envoyez. C\'est prêt.',
      testimonials: 'Témoignages',
      faq: 'Questions fréquentes',
      readyToStart: 'Prêt à simplifier votre facturation ?',
      joinCompanies: 'Rejoignez 500+ entreprises suisses',
      startFree: 'Essai gratuit',
      noCreditCard: 'Sans carte bancaire',
      pricingTitle: 'Simple et transparent',
      pricingSubtitle: 'Pas de frais cachés. Pas de surprises.',
      pricingSection: 'Tarification',
      choose: 'Choisir',
      freeTrial: 'Essai gratuit, sans limite. Sans carte bancaire.',
      createFreeAccount: 'Créer mon compte gratuit',
      joinEntrepreneurs: 'Rejoignez 500+ entrepreneurs suisses. Essai gratuit, sans engagement.',
      swissCompanies: '500+ entreprises suisses',
      legalNotice: 'Mentions légales',
      privacy: 'Confidentialité',
      contact: 'Contact',
      madeIn: 'Made in Switzerland',
      // Features cards
      feature1Title: 'Créez en 2 minutes',
      feature1Desc: 'Interface intuitive. Sélectionnez un client, ajoutez vos articles, c\'est prêt.',
      feature2Title: 'Sécurité Suisse',
      feature2Desc: 'Données chiffrées, serveurs en Suisse, conforme RGPD.',
      feature3Title: '20 Templates PDF',
      feature3Desc: 'Modernes, classiques, minimalistes. Personnalisez à votre image.',
      feature4Title: 'Gestion Clients',
      feature4Desc: 'Historique complet, suivi des paiements, rappels automatiques.',
      feature5Title: 'Module RH & Paie Suisse',
      feature5Desc: 'Fiches de paie, certificats de salaire (Form. 11), absences, 26 cantons. Conforme AVS/AI/APG/LPP/AC.',
      // Advanced features
      advQrBill: 'QR-Facture Suisse',
      advQrBillDesc: 'Code QR conforme SIX, genere automatiquement sur vos PDFs. Vos clients paient en scannant.',
      advHrPayroll: 'Paie & Salaires Suisses',
      advHrPayrollDesc: 'Fiches de paie avec deductions AVS/LPP/AC. Certificats de salaire Form. 11 officiels.',
      advHrDashboard: 'Dashboard RH',
      advHrDashboardDesc: 'Graphiques interactifs : masse salariale, effectifs, couts par departement, KPIs.',
      advAiChatbot: 'Assistant IA',
      advAiChatbotDesc: 'Un chatbot intelligent integre pour vous guider dans toutes les fonctionnalites de l\'app.',
      advRecurring: 'Factures recurrentes',
      advRecurringDesc: 'Programmez vos factures mensuelles ou annuelles. Generation automatique aux dates prevues.',
      advShopify: 'Integration Shopify',
      advShopifyDesc: 'Connectez votre boutique et creez des factures en 1 clic depuis vos commandes.',
      advMultiCurrency: 'Multi-devises',
      advMultiCurrencyDesc: 'Facturez en CHF, EUR, USD ou GBP. Ideal pour vos clients internationaux.',
      advMultiUser: 'Multi-utilisateurs',
      advMultiUserDesc: 'Invitez votre equipe : comptable, assistant. Gerez les permissions par role.',
      advPartialPayments: 'Paiements partiels',
      advPartialPaymentsDesc: 'Enregistrez plusieurs paiements par facture. Suivi automatique du solde restant.',
      advCreditNotes: 'Avoirs & Notes de credit',
      advCreditNotesDesc: 'Creez des avoirs lies a vos factures. Export PDF inclus.',
      advEmailSend: 'Envoi par email',
      advEmailSendDesc: 'Envoyez factures et devis par email avec PDF en piece jointe. SMTP personnalise.',
      advAccountingExport: 'Export comptable',
      advAccountingExportDesc: 'Format compatible Bexio, Cresus. Envoyez directement a votre fiduciaire.',
      advCsvImport: 'Import CSV clients',
      advCsvImportDesc: 'Migrez facilement depuis un autre logiciel. Import en masse en 1 clic.',
      advAbsences: 'Planning & Absences',
      advAbsencesDesc: 'Gerez vacances, maladies, conges. Calendrier avec jours feries par canton suisse.',
      advPdfPreview: 'Previsualisation PDF',
      advPdfPreviewDesc: 'Visualisez vos factures avant envoi. Verifiez chaque detail.',
      advExpenseTracking: 'Suivi des depenses',
      advExpenseTrackingDesc: 'Enregistrez vos depenses avec justificatifs. Calcul automatique du benefice net.',
      advStock: 'Gestion de Stock',
      advStockDesc: 'Inventaire complet avec mouvements, alertes stock bas, import CSV et sync Shopify.',
      advPortal: 'Portail Client',
      advPortalDesc: 'Vos clients consultent et paient leurs factures en ligne via un lien securise.',
      advPwa: 'Application Mobile',
      advPwaDesc: 'Installez Xyron sur votre telephone ou PC comme une vraie application.',
      advProjects: 'Gestion de Projets',
      advProjectsDesc: 'Suivi complet : taches, temps, budget, Gantt, calendrier, collaboration et charge de travail.',
      advProjectReports: 'Rapports Projets',
      advProjectReportsDesc: 'Exports PDF et Excel : rapport projet, temps par collaborateur, rentabilite globale.',
      compStock: 'Gestion de Stock',
      compPortal: 'Portail Client (paiement)',
      compPwa: 'Application Mobile (PWA)',
      compProjects: 'Gestion de Projets',
      compProjectReports: 'Rapports Projets (PDF/Excel)',
      // Stats
      statInvoicesCreated: 'Factures créées',
      statCompanies: 'Entreprises',
      statUptime: 'Disponibilité',
      statSatisfaction: 'Satisfaction',
      // FAQ
      faq1Q: 'Puis-je tester gratuitement ?',
      faq1A: 'Oui ! Créez 3 factures et 3 devis gratuitement, sans carte bancaire. Testez toutes les fonctionnalités.',
      faq2Q: 'Mes données sont-elles sécurisées ?',
      faq2A: 'Absolument. Chiffrement SSL, serveurs en Suisse, sauvegardes quotidiennes. Conforme RGPD et nLPD.',
      faq3Q: 'Comment fonctionne la TVA ?',
      faq3A: 'Configurez votre taux (8.1%, 3.8%, 2.6%) ou indiquez \'non assujetti\'. La mention légale apparaît automatiquement.',
      faq4Q: 'Puis-je personnaliser mes factures ?',
      faq4A: '20 templates au choix : modernes, classiques, minimalistes. Ajoutez votre logo, vos couleurs, vos mentions.',
      faq5Q: 'Comment fonctionne la QR-Facture ?',
      faq5A: 'Le code QR suisse est généré automatiquement sur vos PDFs avec vos coordonnées IBAN. Vos clients peuvent payer en scannant le code.',
      faq6Q: 'Puis-je connecter ma boutique Shopify ?',
      faq6A: 'Oui ! Connectez votre boutique en quelques clics et créez des factures depuis vos commandes Shopify en 1 clic.',
      faq7Q: 'Comment gérer les paiements partiels ?',
      faq7A: 'Enregistrez plusieurs paiements par facture. Le solde restant se calcule automatiquement et apparaît sur vos documents.',
      faq8Q: 'Puis-je créer des factures récurrentes ?',
      faq8A: 'Oui, programmez vos factures mensuelles, trimestrielles ou annuelles. Génération automatique aux dates prévues.',
      // Pricing features
      allFromMonthly: 'Tout du Starter',
      allFromSixMonths: 'Tout du Pro',
      save15: 'Economisez 15%',
      save22: 'Economisez 22%',
      earlyAccess: 'Fonctionnalites en avant-premiere',
      notConvinced: 'Pas encore convaincu ?',
      notConvincedDesc: 'Testez gratuitement tout l\'ERP Xyron Core : facturation, devis, gestion clients, tableau de bord et plus encore.',
      notConvincedLimit: 'Factures et devis illimites - sans carte bancaire.',
      startFreeTrial: 'Demarrer l\'essai gratuit',
      noCommitment: 'Sans engagement. Sans carte bancaire.',
      comparisonTitle: 'Comparatif detaille par modules',
      comparisonSubtitle: 'Trouvez le plan qui correspond a vos besoins',
      compFeatures: 'Fonctionnalites',
      compInvoicing: 'Facturation & Devis',
      compInvoicesQuotes: 'Factures & Devis',
      compQrBill: 'QR-Factures Suisses',
      compPdfTemplates: 'Modeles PDF Premium',
      compRecurring: 'Factures Recurrentes',
      compPartialPayments: 'Paiements Partiels',
      compCreditNotes: 'Avoirs & Notes de credit',
      compEmailSend: 'Envoi par Email',
      compManagement: 'Gestion & Comptabilite',
      compClientCrm: 'Gestion Clients (CRM)',
      compExpenses: 'Suivi des Depenses',
      compAccountingExport: 'Export Comptable',
      compMultiCurrency: 'Multi-devises',
      compMultiUsers: 'Multi-utilisateurs',
      compDashboard: 'Tableau de Bord',
      compPdfPreview: 'Previsualisation PDF',
      compCsvImport: 'Import CSV Clients',
      compAdvanced: 'Avance & Integrations',
      compHrPayroll: 'RH & Salaires Suisses',
      compShopify: 'Synchronisation Shopify',
      compAiAssistant: 'Assistant IA Xyron',
      compAbsences: 'Planning & Absences',
      compAuditLog: 'Journal d\'Audit',
      compSupport: 'Support & Assistance',
      comp1User: '1 utilisateur',
      compUpTo5: 'Jusqu\'a 5',
      compUnlimited: 'Illimite',
      comp5Templates: '5 modeles',
      comp20Templates: '20+ modeles',
      compEmailOnly: 'Email',
      compPriority: 'Prioritaire',
      compDedicated: 'Dedie + Onboarding',
    },
    // Pricing
    pricing: {
      title: 'Tarifs simples et transparents',
      subtitle: 'Choisissez le plan adapte a vos besoins',
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Entreprise',
      allInOne: 'Tout-en-un',
      monthly: 'Mensuel',
      sixMonths: '6 Mois',
      annual: 'Annuel',
      perMonth: '/mois',
      perSixMonths: '/6 mois',
      perYear: '/an',
      popular: 'Populaire',
      bestValue: 'Meilleure valeur',
      save: 'Economisez',
      subscribe: 'S\'abonner',
      features: {
        unlimitedInvoices: 'Factures illimitees',
        unlimitedQuotes: 'Devis illimites',
        unlimitedClients: 'Clients illimites',
        unlimitedInvoicesQuotes: 'Factures & devis illimites',
        pdfTemplates: '20 modeles PDF',
        pdfTemplates20: '20 modeles PDF professionnels',
        qrBill: 'QR-Facture Suisse',
        qrBillSwiss: 'QR-Facture conforme SIX',
        emailSupport: 'Support email',
        multiCurrency: 'Multi-devises (CHF/EUR/USD)',
        csvImport: 'Import CSV clients',
        prioritySupport: 'Support prioritaire',
        multiUser: 'Multi-utilisateurs (equipe)',
        accountingExport: 'Export comptable Bexio/Cresus',
        prioritySupport24: 'Support prioritaire 24h',
        allStarter: 'Tout du plan Starter +',
        hrPayroll: 'Module RH & Paie suisse complet',
        shopifySync: 'Synchronisation Shopify',
        allPro: 'Tout du plan Pro +',
        annualSaving: 'Economisez 159 CHF/an',
        aiAssistant: 'Assistant IA integre',
        stockManagement: 'Gestion de Stock & Inventaire',
        clientPortal: 'Portail Client avec paiement',
        mobileApp: 'Application Mobile (PWA)',
        dedicatedSupport: 'Support dedie & onboarding',
      }
    },
    // Common
    common: {
      loading: 'Chargement...',
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      create: 'Créer',
      download: 'Télécharger',
      preview: 'Aperçu',
      send: 'Envoyer',
      search: 'Rechercher',
      filter: 'Filtrer',
      export: 'Exporter',
      import: 'Importer',
      yes: 'Oui',
      no: 'Non',
      confirm: 'Confirmer',
      back: 'Retour',
      next: 'Suivant',
      close: 'Fermer',
      add: 'Ajouter',
      actions: 'Actions',
      status: 'Statut',
      date: 'Date',
      amount: 'Montant',
      total: 'Total',
      subtotal: 'Sous-total',
      tax: 'TVA',
      noData: 'Aucune donnée',
      all: 'Tous',
      print: 'Imprimer',
      duplicate: 'Dupliquer',
      view: 'Voir',
      details: 'Détails',
    },
    // Auth
    auth: {
      email: 'Email',
      password: 'Mot de passe',
      companyName: 'Nom de l\'entreprise',
      login: 'Se connecter',
      register: 'S\'inscrire',
      forgotPassword: 'Mot de passe oublié ?',
      noAccount: 'Pas encore de compte ?',
      hasAccount: 'Déjà un compte ?',
      createAccount: 'Créer un compte',
      loginHere: 'Connectez-vous ici',
      welcome: 'Bienvenue',
      welcomeBack: 'Bon retour',
      loginSubtitle: 'Connectez-vous à votre compte',
      registerSubtitle: 'Créez votre compte en quelques secondes',
    },
    // Dashboard
    dashboard: {
      title: 'Tableau de bord',
      welcome: 'Bienvenue',
      totalRevenue: 'Chiffre d\'affaires',
      pendingAmount: 'En attente',
      invoicesCount: 'Factures',
      clientsCount: 'Clients',
      recentInvoices: 'Factures récentes',
      newInvoice: 'Nouvelle facture',
      newQuote: 'Nouveau devis',
      viewAll: 'Voir tout',
      thisMonth: 'Ce mois',
      lastMonth: 'Mois dernier',
      thisYear: 'Cette année',
      growth: 'Croissance',
      quickActions: 'Actions rapides',
      overdueInvoices: 'Factures en retard',
      paidThisMonth: 'Payé ce mois',
    },
    // Invoices
    invoices: {
      title: 'Factures',
      create: 'Nouvelle facture',
      number: 'N° Facture',
      client: 'Client',
      date: 'Date',
      dueDate: 'Échéance',
      status: 'Statut',
      amount: 'Montant',
      actions: 'Actions',
      paid: 'Payée',
      sent: 'Envoyée',
      draft: 'Brouillon',
      overdue: 'En retard',
      cancelled: 'Annulée',
      markAsPaid: 'Marquer payée',
      markAsSent: 'Marquer envoyée',
      downloadPdf: 'Télécharger PDF',
      sendByEmail: 'Envoyer par email',
      deleteConfirm: 'Supprimer cette facture ?',
      deleteWarning: 'Cette action est irréversible.',
      noInvoices: 'Aucune facture',
      createFirst: 'Créez votre première facture',
      searchPlaceholder: 'Rechercher une facture...',
      filterByStatus: 'Filtrer par statut',
      exportCsv: 'Exporter CSV',
      viewQr: 'Voir QR-Facture',
      partialPayment: 'Paiement partiel',
      remainingAmount: 'Solde restant',
      paymentHistory: 'Historique des paiements',
    },
    // Quotes
    quotes: {
      title: 'Devis',
      create: 'Nouveau devis',
      number: 'N° Devis',
      client: 'Client',
      date: 'Date',
      validUntil: 'Valide jusqu\'au',
      status: 'Statut',
      amount: 'Montant',
      accepted: 'Accepté',
      pending: 'En attente',
      rejected: 'Refusé',
      expired: 'Expiré',
      convertToInvoice: 'Convertir en facture',
      noQuotes: 'Aucun devis',
      createFirst: 'Créez votre premier devis',
    },
    // Clients
    clients: {
      title: 'Clients',
      create: 'Nouveau client',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Adresse',
      city: 'Ville',
      postalCode: 'Code postal',
      country: 'Pays',
      totalBilled: 'Total facturé',
      totalPaid: 'Total payé',
      balance: 'Solde',
      noClients: 'Aucun client',
      createFirst: 'Ajoutez votre premier client',
      importCsv: 'Importer CSV',
      clientDetails: 'Détails du client',
      invoiceHistory: 'Historique des factures',
    },
    // Settings
    settings: {
      title: 'Paramètres',
      companyInfo: 'Informations entreprise',
      companyName: 'Nom de l\'entreprise',
      address: 'Adresse',
      phone: 'Téléphone',
      email: 'Email',
      website: 'Site web',
      logo: 'Logo',
      uploadLogo: 'Télécharger logo',
      invoiceSettings: 'Paramètres factures',
      defaultPaymentTerms: 'Conditions de paiement',
      defaultNotes: 'Notes par défaut',
      vatSettings: 'Paramètres TVA',
      vatNumber: 'Numéro TVA',
      vatRate: 'Taux TVA',
      vatExempt: 'Non assujetti à la TVA',
      commerceRegister: 'Registre du commerce',
      iban: 'IBAN',
      qrBillSettings: 'Paramètres QR-Facture',
      pdfTemplate: 'Modèle PDF',
      templateColor: 'Couleur du template',
      smtpSettings: 'Paramètres email (SMTP)',
      smtpHost: 'Serveur SMTP',
      smtpPort: 'Port',
      smtpUser: 'Utilisateur',
      smtpPassword: 'Mot de passe',
      saved: 'Paramètres enregistrés',
      currency: 'Devise',
      language: 'Langue',
    },
    // Team
    team: {
      title: 'Gestion d\'équipe',
      invite: 'Inviter un membre',
      role: 'Rôle',
      admin: 'Administrateur',
      accountant: 'Comptable',
      reader: 'Lecteur',
      pending: 'En attente',
      active: 'Actif',
      remove: 'Retirer',
      noMembers: 'Aucun membre',
      inviteSent: 'Invitation envoyée',
    },
    // Sidebar
    sidebar: {
      invoiceManagement: 'ERP Suisse pour PME',
      newInvoice: 'Nouvelle facture',
      newQuote: 'Nouveau devis',
      freeTrial: 'Essai gratuit',
      invoicesLeft: 'factures',
      quotesLeft: 'devis restants',
      viewPlans: 'Voir les abonnements',
      accountExpired: 'Compte expiré',
      activateSubscription: 'Activez votre abonnement pour continuer.',
      subscribeNow: 'S\'abonner maintenant',
      activeSubscription: 'Abonnement actif',
      expiresOn: 'Expire le',
      administrator: 'Administrateur',
    },
    // Fiscal
    fiscal: {
      title: 'Bilan Fiscal',
      year: 'Année',
      revenue: 'Chiffre d\'affaires',
      expenses: 'Dépenses',
      profit: 'Bénéfice net',
      taxDue: 'TVA à reverser',
      downloadReport: 'Télécharger le rapport',
      quarterly: 'Trimestriel',
      monthly: 'Mensuel',
      annual: 'Annuel',
    },
    // Expenses
    expenses: {
      title: 'Dépenses',
      create: 'Nouvelle dépense',
      category: 'Catégorie',
      description: 'Description',
      receipt: 'Justificatif',
      noExpenses: 'Aucune dépense',
    },
    // Shopify
    shopify: {
      title: 'Intégration Shopify',
      connect: 'Connecter Shopify',
      disconnect: 'Déconnecter',
      shopUrl: 'URL de la boutique',
      accessToken: 'Token d\'accès',
      syncOrders: 'Synchroniser les commandes',
      lastSync: 'Dernière synchronisation',
      autoSync: 'Synchronisation automatique',
      orders: 'Commandes',
      createInvoice: 'Créer une facture',
    },
    // Products
    products: {
      title: 'Produits & Services',
      create: 'Nouveau produit',
      name: 'Nom',
      description: 'Description',
      price: 'Prix',
      unit: 'Unité',
      noProducts: 'Aucun produit',
    },
    // Recurring
    recurring: {
      title: 'Factures récurrentes',
      create: 'Nouvelle récurrence',
      frequency: 'Fréquence',
      nextDate: 'Prochaine date',
      lastGenerated: 'Dernière génération',
      weekly: 'Hebdomadaire',
      monthly: 'Mensuel',
      quarterly: 'Trimestriel',
      yearly: 'Annuel',
      active: 'Actif',
      paused: 'En pause',
    },
    // HR & Payroll
    hr: {
      employees: 'Employés',
      payslips: 'Fiches de paie',
      employeesCount: 'employé(s)',
      addEmployee: 'Ajouter un employé',
      searchEmployees: 'Rechercher un employé...',
      noEmployees: 'Aucun employé',
      addFirstEmployee: 'Ajoutez votre premier employé pour commencer',
      name: 'Nom',
      position: 'Poste',
      contract: 'Contrat',
      salary: 'Salaire',
      workRate: 'Taux',
      newEmployee: 'Nouvel employé',
      editEmployee: 'Modifier l\'employé',
      personalInfo: 'Informations personnelles',
      firstName: 'Prénom',
      lastName: 'Nom',
      dateOfBirth: 'Date de naissance',
      email: 'Email',
      phone: 'Téléphone',
      civilStatus: 'État civil',
      single: 'Célibataire',
      married: 'Marié(e)',
      divorced: 'Divorcé(e)',
      widowed: 'Veuf/Veuve',
      children: 'Nombre d\'enfants',
      nationality: 'Nationalité',
      permitType: 'Type de permis',
      address: 'Adresse',
      street: 'Rue',
      postalCode: 'NPA',
      city: 'Ville',
      canton: 'Canton',
      employment: 'Emploi',
      department: 'Département',
      contractType: 'Type de contrat',
      startDate: 'Date d\'entrée',
      avsNumber: 'Numéro AVS',
      salaryInfo: 'Salaire',
      grossSalary: 'Salaire brut mensuel (CHF)',
      has13thMonth: '13ème salaire',
      lppEnrolled: 'Affilié LPP',
      iban: 'IBAN',
      bankName: 'Nom de la banque',
      mealAllowance: 'Indemnité repas',
      transportAllowance: 'Indemnité transport',
      otherAllowances: 'Autres indemnités',
      employeeCreated: 'Employé créé avec succès',
      employeeUpdated: 'Employé mis à jour',
      employeeDeleted: 'Employé supprimé',
      confirmDelete: 'Voulez-vous vraiment supprimer cet employé ?',
      viewPayslips: 'Voir les fiches de paie',
      // Payslips
      newPayslip: 'Nouvelle fiche de paie',
      noPayslips: 'Aucune fiche de paie',
      createFirstPayslip: 'Créez votre première fiche de paie',
      addEmployeesFirst: 'Ajoutez d\'abord des employés',
      selectEmployee: 'Sélectionner un employé',
      employee: 'Employé',
      month: 'Mois',
      year: 'Année',
      workedDays: 'Jours travaillés',
      overtimeHours: 'Heures supplémentaires',
      bonus: 'Prime',
      otherDeductions: 'Autres déductions',
      notes: 'Remarques',
      notesPlaceholder: 'Notes optionnelles...',
      calculate: 'Calculer',
      payslipPreview: 'Aperçu de la fiche de paie',
      earnings: 'Revenus',
      baseSalary: 'Salaire de base',
      '13thMonth': '13ème salaire',
      allowances: 'Indemnités',
      overtimePay: 'Heures supplémentaires',
      totalGross: 'Total brut',
      deductions: 'Déductions',
      totalDeductions: 'Total déductions',
      netSalary: 'Salaire net',
      createPayslip: 'Créer la fiche de paie',
      payslipCreated: 'Fiche de paie créée',
      payslipValidated: 'Fiche de paie validée',
      period: 'Période',
      gross: 'Brut',
      net: 'Net',
      status: 'Statut',
      totalNet: 'Total net',
      payslipsCount: 'Fiches',
      salaryCertificate: 'Certificat de salaire',
      certificateDownloaded: 'Certificat téléchargé',
      certificateError: 'Erreur: Aucune fiche de paie validée trouvée',
      // Absences
      absencesPlanning: 'Planning & Absences',
      newAbsence: 'Nouvelle absence',
      noAbsences: 'Aucune absence',
      noAbsencesThisMonth: 'Aucune demande d\'absence ce mois-ci',
      absenceType: 'Type d\'absence',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      reason: 'Motif',
      reasonPlaceholder: 'Motif optionnel...',
      submitRequest: 'Soumettre la demande',
      absenceCreated: 'Demande d\'absence créée',
      absenceApproved: 'Absence approuvée',
      absenceRejected: 'Absence refusée',
      pendingRequests: 'En attente',
      approved: 'Approuvées',
      totalAbsenceDays: 'Jours d\'absence',
      publicHolidays: 'Jours fériés',
      publicHolidaysIn: 'Jours fériés en',
      days: 'Jours',
      type: 'Type',
      fillRequired: 'Veuillez remplir tous les champs obligatoires',
      // Accounting
      accountingEntries: 'Écritures comptables',
      journalEntries: 'Journal des écritures',
      exportCSV: 'Exporter CSV',
      exportSuccess: 'Export réussi',
      noEntries: 'Aucune écriture',
      noValidatedPayslips: 'Aucune fiche de paie validée pour cette période',
      entriesBalanced: 'Écritures équilibrées',
      entriesUnbalanced: 'Écritures non équilibrées',
      grossSalaries: 'Salaires bruts',
      employerCharges: 'Charges patronales',
      totalCost: 'Coût total',
      netSalaries: 'Salaires nets',
      account: 'Compte',
      accountName: 'Libellé',
      description: 'Description',
      debit: 'Débit',
      credit: 'Crédit',
      totals: 'TOTAUX',
      accountLegend: 'Plan comptable utilisé',
      date: 'Date',
      // Dashboard RH
      dashboard: 'Dashboard RH',
      dashboardSubtitle: 'Vue d\'ensemble des ressources humaines',
      totalEmployees: 'Employés',
      monthlyPayroll: 'Masse salariale',
      avgSalary: 'Salaire moyen',
      pendingAbsences: 'Absences en attente',
      ytdSummary: 'Récapitulatif annuel',
      contractTypes: 'Types de contrat',
      quickActions: 'Actions rapides',
      alertsReminders: 'Alertes & Rappels',
    },
  },
  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      pricing: 'Preise',
      login: 'Anmelden',
      register: 'Registrieren',
      dashboard: 'Dashboard',
      invoices: 'Rechnungen',
      quotes: 'Offerten',
      clients: 'Kunden',
      products: 'Produkte/Dienste',
      projects: 'Projekte',
      expenses: 'Ausgaben',
      revenues: 'Einnahmen',
      projections: 'Prognosen',
      fiscal: 'Steuerbilanz',
      team: 'Team',
      settings: 'Einstellungen',
      logout: 'Abmelden',
      search: 'Suchen...',
      recurring: 'Wiederkehrend',
      shopify: 'Shopify',
      reminders: 'Erinnerungen',
      help: 'Hilfe & FAQ',
      support: 'Support',
      adminTickets: 'Tickets',
      admin: 'Verwaltung',
      employees: 'Mitarbeiter',
      payslips: 'Lohnabrechnungen',
      absences: 'Planung',
      accounting: 'Buchhaltung',
      hrDashboard: 'HR Dashboard',
    },
    // Landing page
    landing: {
      heroTitle: 'Verwalten.',
      heroTitleHighlight: 'Einfach.',
      heroSubtitle: 'Schweizer ERP All-in-One: Rechnungen, HR, Lohn, Buchhaltung. Für Selbstständige und KMU.',
      cta: 'Kostenlos starten',
      watchDemo: 'Demo ansehen',
      trustedBy: 'Sie vertrauen uns',
      features: 'Funktionen',
      featuresTitle: 'Alles was Sie brauchen',
      featuresSubtitle: 'Ein komplettes Tool zur Verwaltung Ihrer Rechnungsstellung.',
      newFeatures: 'Neue Funktionen 2026',
      newFeaturesTitle: 'Die Rechnungsstellung',
      newFeaturesTitleHighlight: 'der neuen Generation',
      newFeaturesSubtitle: 'Leistungsstarke Tools zur Automatisierung Ihrer Buchhaltung und Zeitersparnis.',
      discoverFree: 'Kostenlos entdecken',
      howItWorks: 'So funktioniert es',
      threeSteps: '3 Schritte. Das ist alles.',
      step1Title: 'Konto erstellen',
      step1Desc: 'Registrierung in 30 Sekunden. Ohne Kreditkarte.',
      step2Title: 'Kunden hinzufügen',
      step2Desc: 'Importieren oder erstellen Sie Ihre Kundenkarten mit einem Klick.',
      step3Title: 'Rechnung erstellen!',
      step3Desc: 'Auswählen, ausfüllen, senden. Fertig.',
      testimonials: 'Referenzen',
      faq: 'Häufige Fragen',
      readyToStart: 'Bereit, Ihre Rechnungsstellung zu vereinfachen?',
      joinCompanies: 'Schliessen Sie sich 500+ Schweizer Unternehmen an',
      startFree: 'Kostenlose Testversion',
      noCreditCard: 'Ohne Kreditkarte',
      pricingTitle: 'Einfach und transparent',
      pricingSubtitle: 'Keine versteckten Gebühren. Keine Überraschungen.',
      pricingSection: 'Preisgestaltung',
      choose: 'Wählen',
      freeTrial: 'Kostenlose Testversion, ohne Limit. Ohne Kreditkarte.',
      createFreeAccount: 'Kostenloses Konto erstellen',
      joinEntrepreneurs: 'Schliessen Sie sich 500+ Schweizer Unternehmern an. Kostenlose Testversion.',
      swissCompanies: '500+ Schweizer Unternehmen',
      legalNotice: 'Impressum',
      privacy: 'Datenschutz',
      contact: 'Kontakt',
      madeIn: 'Made in Switzerland',
      feature1Title: 'In 2 Minuten erstellen',
      feature1Desc: 'Intuitive Benutzeroberfläche. Kunde auswählen, Artikel hinzufügen, fertig.',
      feature2Title: 'Schweizer Sicherheit',
      feature2Desc: 'Verschlüsselte Daten, Server in der Schweiz, DSGVO-konform.',
      feature3Title: '20 PDF-Vorlagen',
      feature3Desc: 'Modern, klassisch, minimalistisch. Personalisieren Sie nach Ihrem Bild.',
      feature4Title: 'Kundenverwaltung',
      feature4Desc: 'Vollständige Historie, Zahlungsverfolgung, automatische Erinnerungen.',
      feature5Title: 'HR & Lohnmodul Schweiz',
      feature5Desc: 'Lohnabrechnungen, Lohnausweise (Form. 11), Abwesenheiten, 26 Kantone. AVS/AI/APG/LPP/AC konform.',
      advQrBill: 'QR-Rechnung Schweiz',
      advQrBillDesc: 'SIX-konformer QR-Code, automatisch auf Ihren PDFs generiert. Kunden zahlen per Scan.',
      advHrPayroll: 'Schweizer Lohnbuchhaltung',
      advHrPayrollDesc: 'Lohnabrechnungen mit AVS/LPP/AC Abzuegen. Offizielle Lohnausweise Form. 11.',
      advHrDashboard: 'HR Dashboard',
      advHrDashboardDesc: 'Interaktive Grafiken: Lohnsumme, Mitarbeiter, Kosten pro Abteilung, KPIs.',
      advAiChatbot: 'KI-Assistent',
      advAiChatbotDesc: 'Ein intelligenter integrierter Chatbot, der Sie durch alle App-Funktionen fuehrt.',
      advRecurring: 'Wiederkehrende Rechnungen',
      advRecurringDesc: 'Planen Sie monatliche oder jaehrliche Rechnungen. Automatische Generierung.',
      advShopify: 'Shopify-Integration',
      advShopifyDesc: 'Verbinden Sie Ihren Shop und erstellen Sie Rechnungen mit 1 Klick aus Bestellungen.',
      advMultiCurrency: 'Multi-Waehrung',
      advMultiCurrencyDesc: 'Rechnungen in CHF, EUR, USD oder GBP. Ideal fuer internationale Kunden.',
      advMultiUser: 'Multi-Benutzer',
      advMultiUserDesc: 'Laden Sie Ihr Team ein: Buchhalter, Assistent. Verwalten Sie Berechtigungen.',
      advPartialPayments: 'Teilzahlungen',
      advPartialPaymentsDesc: 'Mehrere Zahlungen pro Rechnung erfassen. Automatische Saldoverfolgung.',
      advCreditNotes: 'Gutschriften',
      advCreditNotesDesc: 'Erstellen Sie Gutschriften zu Ihren Rechnungen. PDF-Export inklusive.',
      advEmailSend: 'E-Mail-Versand',
      advEmailSendDesc: 'Senden Sie Rechnungen und Offerten per E-Mail mit PDF-Anhang. Eigener SMTP.',
      advAccountingExport: 'Buchhaltungsexport',
      advAccountingExportDesc: 'Format kompatibel mit Bexio, Cresus. Direkt an Ihren Treuhaender senden.',
      advCsvImport: 'CSV-Import Kunden',
      advCsvImportDesc: 'Einfache Migration von anderer Software. Massenimport mit 1 Klick.',
      advAbsences: 'Planung & Abwesenheiten',
      advAbsencesDesc: 'Verwalten Sie Ferien, Krankheiten, Urlaub. Kalender mit kantonalen Feiertagen.',
      advPdfPreview: 'PDF-Vorschau',
      advPdfPreviewDesc: 'Ueberpruefen Sie Ihre Rechnungen vor dem Versand. Jedes Detail pruefen.',
      advExpenseTracking: 'Ausgabenverfolgung',
      advExpenseTrackingDesc: 'Erfassen Sie Ihre Ausgaben mit Belegen. Automatische Nettogewinnberechnung.',
      advStock: 'Lagerverwaltung',
      advStockDesc: 'Vollstaendiges Inventar mit Bewegungen, Warnungen, CSV-Import und Shopify-Sync.',
      advPortal: 'Kundenportal',
      advPortalDesc: 'Ihre Kunden koennen Rechnungen online einsehen und bezahlen.',
      advPwa: 'Mobile App',
      advPwaDesc: 'Installieren Sie Xyron als App auf Ihrem Handy oder PC.',
      advProjects: 'Projektmanagement',
      advProjectsDesc: 'Komplettes Tracking: Aufgaben, Zeit, Budget, Gantt, Kalender, Zusammenarbeit und Auslastung.',
      advProjectReports: 'Projektberichte',
      advProjectReportsDesc: 'PDF- und Excel-Exporte: Projektbericht, Zeit pro Mitarbeiter, Gesamtrentabilitaet.',
      compStock: 'Lagerverwaltung',
      compPortal: 'Kundenportal (Zahlung)',
      compPwa: 'Mobile App (PWA)',
      compProjects: 'Projektmanagement',
      compProjectReports: 'Projektberichte (PDF/Excel)',
      statInvoicesCreated: 'Erstellte Rechnungen',
      statCompanies: 'Unternehmen',
      statUptime: 'Verfügbarkeit',
      statSatisfaction: 'Zufriedenheit',
      faq1Q: 'Kann ich kostenlos testen?',
      faq1A: 'Ja! Testen Sie alle Funktionen kostenlos, ohne Kreditkarte. Mit einem Einladungscode erhalten Sie 7 Tage kostenlosen Pro-Zugang.',
      faq2Q: 'Sind meine Daten sicher?',
      faq2A: 'Absolut. SSL-Verschlüsselung, Server in der Schweiz, tägliche Backups. DSGVO-konform.',
      faq3Q: 'Wie funktioniert die MwSt?',
      faq3A: 'Konfigurieren Sie Ihren Satz (8.1%, 3.8%, 2.6%) oder geben Sie \'nicht steuerpflichtig\' an.',
      faq4Q: 'Kann ich meine Rechnungen anpassen?',
      faq4A: '20 Vorlagen zur Auswahl: modern, klassisch, minimalistisch. Fügen Sie Ihr Logo hinzu.',
      faq5Q: 'Wie funktioniert die QR-Rechnung?',
      faq5A: 'Der Schweizer QR-Code wird automatisch auf Ihren PDFs mit Ihren IBAN-Koordinaten generiert.',
      faq6Q: 'Kann ich meinen Shopify-Shop verbinden?',
      faq6A: 'Ja! Verbinden Sie Ihren Shop mit wenigen Klicks und erstellen Sie Rechnungen aus Shopify-Bestellungen.',
      faq7Q: 'Wie verwalte ich Teilzahlungen?',
      faq7A: 'Erfassen Sie mehrere Zahlungen pro Rechnung. Der Restbetrag wird automatisch berechnet.',
      faq8Q: 'Kann ich wiederkehrende Rechnungen erstellen?',
      faq8A: 'Ja, planen Sie monatliche, vierteljährliche oder jährliche Rechnungen. Automatische Generierung.',
      allFromMonthly: 'Alles vom Monatlichen',
      allFromSixMonths: 'Alles von 6 Monaten',
      save15: '15% sparen',
      save22: '22% sparen',
      earlyAccess: 'Früher Zugang zu Funktionen',
      notConvinced: 'Noch nicht uberzeugt?',
      notConvincedDesc: 'Testen Sie das gesamte Xyron Core ERP kostenlos: Rechnungen, Offerten, Kundenverwaltung, Dashboard und mehr.',
      notConvincedLimit: 'Unbegrenzte Rechnungen und Offerten - ohne Kreditkarte.',
      startFreeTrial: 'Kostenlose Testversion starten',
      noCommitment: 'Ohne Verpflichtung. Ohne Kreditkarte.',
      comparisonTitle: 'Detaillierter Modulvergleich',
      comparisonSubtitle: 'Finden Sie den Plan, der zu Ihren Beduerfnissen passt',
      compFeatures: 'Funktionen',
      compInvoicing: 'Rechnungen & Offerten',
      compInvoicesQuotes: 'Rechnungen & Offerten',
      compQrBill: 'QR-Rechnungen Schweiz',
      compPdfTemplates: 'Premium PDF-Vorlagen',
      compRecurring: 'Wiederkehrende Rechnungen',
      compPartialPayments: 'Teilzahlungen',
      compCreditNotes: 'Gutschriften',
      compEmailSend: 'E-Mail-Versand',
      compManagement: 'Verwaltung & Buchhaltung',
      compClientCrm: 'Kundenverwaltung (CRM)',
      compExpenses: 'Ausgabenverfolgung',
      compAccountingExport: 'Buchhaltungsexport',
      compMultiCurrency: 'Multi-Waehrung',
      compMultiUsers: 'Multi-Benutzer',
      compDashboard: 'Dashboard',
      compPdfPreview: 'PDF-Vorschau',
      compCsvImport: 'CSV-Import Kunden',
      compAdvanced: 'Erweitert & Integrationen',
      compHrPayroll: 'Schweizer HR & Lohn',
      compShopify: 'Shopify-Synchronisation',
      compAiAssistant: 'KI-Assistent Xyron',
      compAbsences: 'Planung & Abwesenheiten',
      compAuditLog: 'Audit-Journal',
      compSupport: 'Support & Hilfe',
      comp1User: '1 Benutzer',
      compUpTo5: 'Bis zu 5',
      compUnlimited: 'Unbegrenzt',
      comp5Templates: '5 Vorlagen',
      comp20Templates: '20+ Vorlagen',
      compEmailOnly: 'E-Mail',
      compPriority: 'Prioritaet',
      compDedicated: 'Dediziert + Onboarding',
    },
    // Pricing
    pricing: {
      title: 'Einfache und transparente Preise',
      subtitle: 'Wählen Sie den Plan, der zu Ihren Bedürfnissen passt',
      monthly: 'Monatlich',
      sixMonths: '6 Monate',
      annual: 'Jaehrlich',
      starter: 'Starter',
      pro: 'Pro',
      allInOne: 'All-in-one',
      perMonth: '/Monat',
      perSixMonths: '/6 Monate',
      perYear: '/Jahr',
      popular: 'Beliebt',
      bestValue: 'Bester Wert',
      save: 'Sparen Sie',
      subscribe: 'Abonnieren',
      features: {
        unlimitedInvoices: 'Unbegrenzte Rechnungen',
        unlimitedQuotes: 'Unbegrenzte Offerten',
        unlimitedClients: 'Unbegrenzte Kunden',
        pdfTemplates: '20 PDF-Vorlagen',
        qrBill: 'QR-Rechnung Schweiz',
        emailSupport: 'E-Mail-Support',
        multiCurrency: 'Multi-Währung (CHF/EUR/USD)',
        csvImport: 'CSV-Import Kunden',
        prioritySupport: 'Prioritäts-Support',
        multiUser: 'Multi-Benutzer (Team)',
        accountingExport: 'Buchhaltungsexport Bexio/Crésus',
        prioritySupport24: 'Prioritäts-Support 24h',
        unlimitedInvoicesQuotes: 'Unbegrenzte Rechnungen & Offerten',
        pdfTemplates20: '20 PDF-Vorlagen',
        qrBillSwiss: 'QR-Rechnung Schweiz (SIX)',
        allStarter: 'Alles aus Starter +',
        hrPayroll: 'Schweizer HR & Lohn',
        shopifySync: 'Shopify-Synchronisation',
        allPro: 'Alles aus Pro +',
        annualSaving: '159 CHF/Jahr sparen',
        aiAssistant: 'KI-Assistent integriert',
        stockManagement: 'Lagerverwaltung & Inventar',
        clientPortal: 'Kundenportal mit Zahlung',
        mobileApp: 'Mobile App (PWA)',
        dedicatedSupport: 'Dedizierter Support & Onboarding',
      }
    },
    // Common
    common: {
      loading: 'Laden...',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      create: 'Erstellen',
      download: 'Herunterladen',
      preview: 'Vorschau',
      send: 'Senden',
      search: 'Suchen',
      filter: 'Filtern',
      export: 'Exportieren',
      import: 'Importieren',
      yes: 'Ja',
      no: 'Nein',
      confirm: 'Bestätigen',
      back: 'Zurück',
      next: 'Weiter',
      close: 'Schliessen',
      add: 'Hinzufügen',
      actions: 'Aktionen',
      status: 'Status',
      date: 'Datum',
      amount: 'Betrag',
      total: 'Gesamt',
      subtotal: 'Zwischensumme',
      tax: 'MwSt',
      noData: 'Keine Daten',
      all: 'Alle',
      print: 'Drucken',
      duplicate: 'Duplizieren',
      view: 'Ansehen',
      details: 'Details',
    },
    // Auth
    auth: {
      email: 'E-Mail',
      password: 'Passwort',
      companyName: 'Firmenname',
      login: 'Anmelden',
      register: 'Registrieren',
      forgotPassword: 'Passwort vergessen?',
      noAccount: 'Noch kein Konto?',
      hasAccount: 'Bereits ein Konto?',
      createAccount: 'Konto erstellen',
      loginHere: 'Hier anmelden',
      welcome: 'Willkommen',
      welcomeBack: 'Willkommen zurück',
      loginSubtitle: 'Melden Sie sich bei Ihrem Konto an',
      registerSubtitle: 'Erstellen Sie Ihr Konto in Sekunden',
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Willkommen',
      totalRevenue: 'Gesamtumsatz',
      pendingAmount: 'Ausstehend',
      invoicesCount: 'Rechnungen',
      clientsCount: 'Kunden',
      recentInvoices: 'Aktuelle Rechnungen',
      newInvoice: 'Neue Rechnung',
      newQuote: 'Neue Offerte',
      viewAll: 'Alle ansehen',
      thisMonth: 'Diesen Monat',
      lastMonth: 'Letzten Monat',
      thisYear: 'Dieses Jahr',
      growth: 'Wachstum',
      quickActions: 'Schnellaktionen',
      overdueInvoices: 'Überfällige Rechnungen',
      paidThisMonth: 'Diesen Monat bezahlt',
    },
    // Invoices
    invoices: {
      title: 'Rechnungen',
      create: 'Neue Rechnung',
      number: 'Rechnungsnr.',
      client: 'Kunde',
      date: 'Datum',
      dueDate: 'Fällig am',
      status: 'Status',
      amount: 'Betrag',
      actions: 'Aktionen',
      paid: 'Bezahlt',
      sent: 'Gesendet',
      draft: 'Entwurf',
      overdue: 'Überfällig',
      cancelled: 'Storniert',
      markAsPaid: 'Als bezahlt markieren',
      markAsSent: 'Als gesendet markieren',
      downloadPdf: 'PDF herunterladen',
      sendByEmail: 'Per E-Mail senden',
      deleteConfirm: 'Diese Rechnung löschen?',
      deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      noInvoices: 'Keine Rechnungen',
      createFirst: 'Erstellen Sie Ihre erste Rechnung',
      searchPlaceholder: 'Rechnung suchen...',
      filterByStatus: 'Nach Status filtern',
      exportCsv: 'CSV exportieren',
      viewQr: 'QR-Rechnung ansehen',
      partialPayment: 'Teilzahlung',
      remainingAmount: 'Restbetrag',
      paymentHistory: 'Zahlungshistorie',
    },
    // Quotes
    quotes: {
      title: 'Offerten',
      create: 'Neue Offerte',
      number: 'Offertennr.',
      client: 'Kunde',
      date: 'Datum',
      validUntil: 'Gültig bis',
      status: 'Status',
      amount: 'Betrag',
      accepted: 'Angenommen',
      pending: 'Ausstehend',
      rejected: 'Abgelehnt',
      expired: 'Abgelaufen',
      convertToInvoice: 'In Rechnung umwandeln',
      noQuotes: 'Keine Offerten',
      createFirst: 'Erstellen Sie Ihre erste Offerte',
    },
    // Clients
    clients: {
      title: 'Kunden',
      create: 'Neuer Kunde',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      address: 'Adresse',
      city: 'Stadt',
      postalCode: 'Postleitzahl',
      country: 'Land',
      totalBilled: 'Gesamt in Rechnung gestellt',
      totalPaid: 'Gesamt bezahlt',
      balance: 'Saldo',
      noClients: 'Keine Kunden',
      createFirst: 'Fügen Sie Ihren ersten Kunden hinzu',
      importCsv: 'CSV importieren',
      clientDetails: 'Kundendetails',
      invoiceHistory: 'Rechnungshistorie',
    },
    // Settings
    settings: {
      title: 'Einstellungen',
      companyInfo: 'Firmeninformationen',
      companyName: 'Firmenname',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'E-Mail',
      website: 'Website',
      logo: 'Logo',
      uploadLogo: 'Logo hochladen',
      invoiceSettings: 'Rechnungseinstellungen',
      defaultPaymentTerms: 'Zahlungsbedingungen',
      defaultNotes: 'Standardnotizen',
      vatSettings: 'MwSt-Einstellungen',
      vatNumber: 'MwSt-Nummer',
      vatRate: 'MwSt-Satz',
      vatExempt: 'Nicht steuerpflichtig',
      commerceRegister: 'Handelsregister',
      iban: 'IBAN',
      qrBillSettings: 'QR-Rechnungseinstellungen',
      pdfTemplate: 'PDF-Vorlage',
      templateColor: 'Vorlagenfarbe',
      smtpSettings: 'E-Mail-Einstellungen (SMTP)',
      smtpHost: 'SMTP-Server',
      smtpPort: 'Port',
      smtpUser: 'Benutzer',
      smtpPassword: 'Passwort',
      saved: 'Einstellungen gespeichert',
      currency: 'Währung',
      language: 'Sprache',
    },
    // Team
    team: {
      title: 'Teamverwaltung',
      invite: 'Mitglied einladen',
      role: 'Rolle',
      admin: 'Administrator',
      accountant: 'Buchhalter',
      reader: 'Leser',
      pending: 'Ausstehend',
      active: 'Aktiv',
      remove: 'Entfernen',
      noMembers: 'Keine Mitglieder',
      inviteSent: 'Einladung gesendet',
    },
    // Sidebar
    sidebar: {
      invoiceManagement: 'Schweizer ERP fuer KMU',
      newInvoice: 'Neue Rechnung',
      newQuote: 'Neue Offerte',
      freeTrial: 'Kostenlose Testversion',
      invoicesLeft: 'Rechnungen',
      quotesLeft: 'Offerten übrig',
      viewPlans: 'Abonnements ansehen',
      accountExpired: 'Konto abgelaufen',
      activateSubscription: 'Aktivieren Sie Ihr Abonnement.',
      subscribeNow: 'Jetzt abonnieren',
      activeSubscription: 'Aktives Abonnement',
      expiresOn: 'Läuft ab am',
      administrator: 'Administrator',
    },
    // Fiscal
    fiscal: {
      title: 'Steuerbilanz',
      year: 'Jahr',
      revenue: 'Umsatz',
      expenses: 'Ausgaben',
      profit: 'Nettogewinn',
      taxDue: 'MwSt fällig',
      downloadReport: 'Bericht herunterladen',
      quarterly: 'Vierteljährlich',
      monthly: 'Monatlich',
      annual: 'Jährlich',
    },
    // Expenses
    expenses: {
      title: 'Ausgaben',
      create: 'Neue Ausgabe',
      category: 'Kategorie',
      description: 'Beschreibung',
      receipt: 'Beleg',
      noExpenses: 'Keine Ausgaben',
    },
    // Shopify
    shopify: {
      title: 'Shopify-Integration',
      connect: 'Shopify verbinden',
      disconnect: 'Trennen',
      shopUrl: 'Shop-URL',
      accessToken: 'Zugriffstoken',
      syncOrders: 'Bestellungen synchronisieren',
      lastSync: 'Letzte Synchronisierung',
      autoSync: 'Automatische Synchronisierung',
      orders: 'Bestellungen',
      createInvoice: 'Rechnung erstellen',
    },
    // Products
    products: {
      title: 'Produkte & Dienste',
      create: 'Neues Produkt',
      name: 'Name',
      description: 'Beschreibung',
      price: 'Preis',
      unit: 'Einheit',
      noProducts: 'Keine Produkte',
    },
    // Recurring
    recurring: {
      title: 'Wiederkehrende Rechnungen',
      create: 'Neue Wiederholung',
      frequency: 'Häufigkeit',
      nextDate: 'Nächstes Datum',
      lastGenerated: 'Zuletzt generiert',
      weekly: 'Wöchentlich',
      monthly: 'Monatlich',
      quarterly: 'Vierteljährlich',
      yearly: 'Jährlich',
      active: 'Aktiv',
      paused: 'Pausiert',
    },
    hr: {
      employees: 'Mitarbeiter',
      payslips: 'Lohnabrechnungen',
      employeesCount: 'Mitarbeiter',
      addEmployee: 'Mitarbeiter hinzufügen',
      searchEmployees: 'Mitarbeiter suchen...',
      noEmployees: 'Keine Mitarbeiter',
      addFirstEmployee: 'Fügen Sie Ihren ersten Mitarbeiter hinzu',
      name: 'Name',
      position: 'Position',
      contract: 'Vertrag',
      salary: 'Gehalt',
      workRate: 'Arbeitspensum',
      newEmployee: 'Neuer Mitarbeiter',
      editEmployee: 'Mitarbeiter bearbeiten',
      personalInfo: 'Persönliche Daten',
      firstName: 'Vorname',
      lastName: 'Nachname',
      dateOfBirth: 'Geburtsdatum',
      email: 'E-Mail',
      phone: 'Telefon',
      civilStatus: 'Zivilstand',
      single: 'Ledig',
      married: 'Verheiratet',
      divorced: 'Geschieden',
      widowed: 'Verwitwet',
      children: 'Anzahl Kinder',
      nationality: 'Nationalität',
      permitType: 'Bewilligungsart',
      address: 'Adresse',
      street: 'Strasse',
      postalCode: 'PLZ',
      city: 'Ort',
      canton: 'Kanton',
      employment: 'Anstellung',
      department: 'Abteilung',
      contractType: 'Vertragsart',
      startDate: 'Eintrittsdatum',
      avsNumber: 'AHV-Nummer',
      salaryInfo: 'Gehalt',
      grossSalary: 'Monatliches Bruttogehalt (CHF)',
      has13thMonth: '13. Monatslohn',
      lppEnrolled: 'BVG versichert',
      iban: 'IBAN',
      bankName: 'Bank',
      mealAllowance: 'Essenszulage',
      transportAllowance: 'Transportzulage',
      otherAllowances: 'Weitere Zulagen',
      employeeCreated: 'Mitarbeiter erstellt',
      employeeUpdated: 'Mitarbeiter aktualisiert',
      employeeDeleted: 'Mitarbeiter gelöscht',
      confirmDelete: 'Möchten Sie diesen Mitarbeiter wirklich löschen?',
      viewPayslips: 'Lohnabrechnungen anzeigen',
      newPayslip: 'Neue Lohnabrechnung',
      noPayslips: 'Keine Lohnabrechnungen',
      createFirstPayslip: 'Erstellen Sie Ihre erste Lohnabrechnung',
      addEmployeesFirst: 'Fügen Sie zuerst Mitarbeiter hinzu',
      selectEmployee: 'Mitarbeiter auswählen',
      employee: 'Mitarbeiter',
      month: 'Monat',
      year: 'Jahr',
      workedDays: 'Arbeitstage',
      overtimeHours: 'Überstunden',
      bonus: 'Bonus',
      otherDeductions: 'Weitere Abzüge',
      notes: 'Bemerkungen',
      notesPlaceholder: 'Optionale Notizen...',
      calculate: 'Berechnen',
      payslipPreview: 'Vorschau Lohnabrechnung',
      earnings: 'Einnahmen',
      baseSalary: 'Grundgehalt',
      '13thMonth': '13. Monatslohn',
      allowances: 'Zulagen',
      overtimePay: 'Überstunden',
      totalGross: 'Brutto Total',
      deductions: 'Abzüge',
      totalDeductions: 'Total Abzüge',
      netSalary: 'Nettolohn',
      createPayslip: 'Lohnabrechnung erstellen',
      payslipCreated: 'Lohnabrechnung erstellt',
      payslipValidated: 'Lohnabrechnung validiert',
      period: 'Periode',
      gross: 'Brutto',
      net: 'Netto',
      status: 'Status',
      totalNet: 'Netto Total',
      payslipsCount: 'Abrechnungen',
      salaryCertificate: 'Lohnausweis',
      certificateDownloaded: 'Lohnausweis heruntergeladen',
      certificateError: 'Fehler: Keine validierten Lohnabrechnungen gefunden',
      absencesPlanning: 'Planung & Abwesenheiten',
      newAbsence: 'Neue Abwesenheit',
      noAbsences: 'Keine Abwesenheiten',
      noAbsencesThisMonth: 'Keine Abwesenheitsanträge diesen Monat',
      absenceType: 'Abwesenheitsart',
      endDate: 'Enddatum',
      reason: 'Grund',
      reasonPlaceholder: 'Optionaler Grund...',
      submitRequest: 'Antrag einreichen',
      absenceCreated: 'Abwesenheitsantrag erstellt',
      absenceApproved: 'Abwesenheit genehmigt',
      absenceRejected: 'Abwesenheit abgelehnt',
      pendingRequests: 'Ausstehend',
      approved: 'Genehmigt',
      totalAbsenceDays: 'Abwesenheitstage',
      publicHolidays: 'Feiertage',
      publicHolidaysIn: 'Feiertage in',
      days: 'Tage',
      type: 'Typ',
      fillRequired: 'Bitte alle Pflichtfelder ausfüllen',
      accountingEntries: 'Buchungseinträge',
      journalEntries: 'Buchungsjournal',
      exportCSV: 'CSV exportieren',
      exportSuccess: 'Export erfolgreich',
      noEntries: 'Keine Einträge',
      noValidatedPayslips: 'Keine validierten Lohnabrechnungen für diese Periode',
      entriesBalanced: 'Buchungen ausgeglichen',
      entriesUnbalanced: 'Buchungen nicht ausgeglichen',
      grossSalaries: 'Bruttolöhne',
      employerCharges: 'Arbeitgeberbeiträge',
      totalCost: 'Gesamtkosten',
      netSalaries: 'Nettolöhne',
      account: 'Konto',
      accountName: 'Kontoname',
      description: 'Beschreibung',
      debit: 'Soll',
      credit: 'Haben',
      totals: 'TOTAL',
      accountLegend: 'Verwendeter Kontenplan',
      date: 'Datum',
      dashboard: 'HR Dashboard',
      dashboardSubtitle: 'Übersicht über die Personalressourcen',
      totalEmployees: 'Mitarbeiter',
      monthlyPayroll: 'Lohnsumme',
      avgSalary: 'Durchschnittsgehalt',
      pendingAbsences: 'Ausstehende Abwesenheiten',
      ytdSummary: 'Jahresübersicht',
      contractTypes: 'Vertragsarten',
      quickActions: 'Schnellaktionen',
      alertsReminders: 'Warnungen & Erinnerungen',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      pricing: 'Pricing',
      login: 'Login',
      register: 'Sign up',
      dashboard: 'Dashboard',
      invoices: 'Invoices',
      quotes: 'Quotes',
      clients: 'Clients',
      products: 'Products/Services',
      projects: 'Projects',
      expenses: 'Expenses',
      revenues: 'Revenues',
      projections: 'Projections',
      fiscal: 'Fiscal Report',
      team: 'Team',
      settings: 'Settings',
      logout: 'Logout',
      search: 'Search...',
      recurring: 'Recurring',
      shopify: 'Shopify',
      reminders: 'Reminders',
      help: 'Help & FAQ',
      support: 'Support',
      adminTickets: 'Tickets',
      admin: 'Administration',
      employees: 'Employees',
      payslips: 'Payslips',
      absences: 'Planning',
      accounting: 'Accounting',
      hrDashboard: 'HR Dashboard',
    },
    // Landing page
    landing: {
      heroTitle: 'Manage.',
      heroTitleHighlight: 'Simply.',
      heroSubtitle: 'Swiss ERP all-in-one: invoicing, HR, payroll, accounting. Designed for freelancers and SMEs.',
      cta: 'Start for free',
      watchDemo: 'Watch demo',
      trustedBy: 'Trusted by',
      features: 'Features',
      featuresTitle: 'Everything you need',
      featuresSubtitle: 'A complete tool to manage your invoicing from A to Z.',
      newFeatures: 'New features 2026',
      newFeaturesTitle: 'Next generation',
      newFeaturesTitleHighlight: 'invoicing',
      newFeaturesSubtitle: 'Powerful tools to automate your accounting and save precious time.',
      discoverFree: 'Discover for free',
      howItWorks: 'How it works',
      threeSteps: '3 steps. That\'s it.',
      step1Title: 'Create your account',
      step1Desc: 'Sign up in 30 seconds. No credit card required.',
      step2Title: 'Add your clients',
      step2Desc: 'Import or create your client records in one click.',
      step3Title: 'Invoice!',
      step3Desc: 'Select, fill in, send. Done.',
      testimonials: 'Testimonials',
      faq: 'Frequently asked questions',
      readyToStart: 'Ready to simplify your invoicing?',
      joinCompanies: 'Join 500+ Swiss companies',
      startFree: 'Free trial',
      noCreditCard: 'No credit card required',
      pricingTitle: 'Simple and transparent',
      pricingSubtitle: 'No hidden fees. No surprises.',
      pricingSection: 'Pricing',
      choose: 'Choose',
      freeTrial: 'Free trial, no limits. No credit card.',
      createFreeAccount: 'Create my free account',
      joinEntrepreneurs: 'Join 500+ Swiss entrepreneurs. Free trial, no commitment.',
      swissCompanies: '500+ Swiss companies',
      legalNotice: 'Legal notice',
      privacy: 'Privacy',
      contact: 'Contact',
      madeIn: 'Made in Switzerland',
      feature1Title: 'Create in 2 minutes',
      feature1Desc: 'Intuitive interface. Select a client, add your items, done.',
      feature2Title: 'Swiss Security',
      feature2Desc: 'Encrypted data, servers in Switzerland, GDPR compliant.',
      feature3Title: '20 PDF Templates',
      feature3Desc: 'Modern, classic, minimalist. Customize to your image.',
      feature4Title: 'Client Management',
      feature4Desc: 'Complete history, payment tracking, automatic reminders.',
      feature5Title: 'Swiss HR & Payroll Module',
      feature5Desc: 'Payslips, salary certificates (Form. 11), absences, 26 cantons. AVS/AI/APG/LPP/AC compliant.',
      advQrBill: 'Swiss QR-bill',
      advQrBillDesc: 'SIX-compliant QR code, automatically generated on your PDFs. Clients pay by scanning.',
      advHrPayroll: 'Swiss Payroll',
      advHrPayrollDesc: 'Payslips with AVS/LPP/AC deductions. Official salary certificates Form. 11.',
      advHrDashboard: 'HR Dashboard',
      advHrDashboardDesc: 'Interactive charts: payroll costs, headcount, cost per department, KPIs.',
      advAiChatbot: 'AI Assistant',
      advAiChatbotDesc: 'A smart built-in chatbot to guide you through all the app features.',
      advRecurring: 'Recurring invoices',
      advRecurringDesc: 'Schedule monthly or annual invoices. Automatic generation at planned dates.',
      advShopify: 'Shopify integration',
      advShopifyDesc: 'Connect your store and create invoices with 1 click from your orders.',
      advMultiCurrency: 'Multi-currency',
      advMultiCurrencyDesc: 'Invoice in CHF, EUR, USD or GBP. Ideal for international clients.',
      advMultiUser: 'Multi-user',
      advMultiUserDesc: 'Invite your team: accountant, assistant. Manage permissions by role.',
      advPartialPayments: 'Partial payments',
      advPartialPaymentsDesc: 'Record multiple payments per invoice. Automatic balance tracking.',
      advCreditNotes: 'Credit notes',
      advCreditNotesDesc: 'Create credit notes linked to your invoices. PDF export included.',
      advEmailSend: 'Email sending',
      advEmailSendDesc: 'Send invoices and quotes by email with PDF attachment. Custom SMTP.',
      advAccountingExport: 'Accounting export',
      advAccountingExportDesc: 'Format compatible with Bexio, Cresus. Send directly to your accountant.',
      advCsvImport: 'CSV client import',
      advCsvImportDesc: 'Easily migrate from another software. Mass import in 1 click.',
      advAbsences: 'Planning & Absences',
      advAbsencesDesc: 'Manage holidays, sick leave, time off. Calendar with cantonal public holidays.',
      advPdfPreview: 'PDF preview',
      advPdfPreviewDesc: 'View your invoices before sending. Check every detail.',
      advExpenseTracking: 'Expense tracking',
      advExpenseTrackingDesc: 'Record your expenses with receipts. Automatic net profit calculation.',
      advStock: 'Stock Management',
      advStockDesc: 'Full inventory with movements, low stock alerts, CSV import and Shopify sync.',
      advPortal: 'Client Portal',
      advPortalDesc: 'Your clients view and pay invoices online via a secure link.',
      advPwa: 'Mobile App',
      advPwaDesc: 'Install Xyron on your phone or PC as a native app.',
      advProjects: 'Project Management',
      advProjectsDesc: 'Full tracking: tasks, time, budget, Gantt, calendar, collaboration and workload.',
      advProjectReports: 'Project Reports',
      advProjectReportsDesc: 'PDF and Excel exports: project report, time per collaborator, overall profitability.',
      compStock: 'Stock Management',
      compPortal: 'Client Portal (payment)',
      compPwa: 'Mobile App (PWA)',
      compProjects: 'Project Management',
      compProjectReports: 'Project Reports (PDF/Excel)',
      statInvoicesCreated: 'Invoices created',
      statCompanies: 'Companies',
      statUptime: 'Uptime',
      statSatisfaction: 'Satisfaction',
      faq1Q: 'Can I try for free?',
      faq1A: 'Yes! Test all features for free, no credit card required. With an invitation code, get 7 days of free Pro access.',
      faq2Q: 'Is my data secure?',
      faq2A: 'Absolutely. SSL encryption, servers in Switzerland, daily backups. GDPR compliant.',
      faq3Q: 'How does VAT work?',
      faq3A: 'Configure your rate (8.1%, 3.8%, 2.6%) or indicate \'VAT exempt\'. The legal notice appears automatically.',
      faq4Q: 'Can I customize my invoices?',
      faq4A: '20 templates to choose from: modern, classic, minimalist. Add your logo, colors, notes.',
      faq5Q: 'How does the QR-bill work?',
      faq5A: 'The Swiss QR code is automatically generated on your PDFs with your IBAN. Clients can pay by scanning.',
      faq6Q: 'Can I connect my Shopify store?',
      faq6A: 'Yes! Connect your store in a few clicks and create invoices from Shopify orders in 1 click.',
      faq7Q: 'How do I manage partial payments?',
      faq7A: 'Record multiple payments per invoice. The remaining balance is calculated automatically.',
      faq8Q: 'Can I create recurring invoices?',
      faq8A: 'Yes, schedule monthly, quarterly or annual invoices. Automatic generation at planned dates.',
      allFromMonthly: 'All from Monthly',
      allFromSixMonths: 'All from 6 Months',
      save15: 'Save 15%',
      save22: 'Save 22%',
      earlyAccess: 'Early access to features',
      notConvinced: 'Not convinced yet?',
      notConvincedDesc: 'Try the full Xyron Core ERP for free: invoicing, quotes, client management, dashboard and more.',
      notConvincedLimit: 'Unlimited invoices and quotes - no credit card required.',
      startFreeTrial: 'Start free trial',
      noCommitment: 'No commitment. No credit card.',
      comparisonTitle: 'Detailed module comparison',
      comparisonSubtitle: 'Find the plan that matches your needs',
      compFeatures: 'Features',
      compInvoicing: 'Invoicing & Quotes',
      compInvoicesQuotes: 'Invoices & Quotes',
      compQrBill: 'Swiss QR-Bills',
      compPdfTemplates: 'Premium PDF Templates',
      compRecurring: 'Recurring Invoices',
      compPartialPayments: 'Partial Payments',
      compCreditNotes: 'Credit Notes',
      compEmailSend: 'Email Sending',
      compManagement: 'Management & Accounting',
      compClientCrm: 'Client Management (CRM)',
      compExpenses: 'Expense Tracking',
      compAccountingExport: 'Accounting Export',
      compMultiCurrency: 'Multi-currency',
      compMultiUsers: 'Multi-users',
      compDashboard: 'Dashboard',
      compPdfPreview: 'PDF Preview',
      compCsvImport: 'CSV Client Import',
      compAdvanced: 'Advanced & Integrations',
      compHrPayroll: 'Swiss HR & Payroll',
      compShopify: 'Shopify Sync',
      compAiAssistant: 'Xyron AI Assistant',
      compAbsences: 'Planning & Absences',
      compAuditLog: 'Audit Log',
      compSupport: 'Support & Assistance',
      comp1User: '1 user',
      compUpTo5: 'Up to 5',
      compUnlimited: 'Unlimited',
      comp5Templates: '5 templates',
      comp20Templates: '20+ templates',
      compEmailOnly: 'Email',
      compPriority: 'Priority',
      compDedicated: 'Dedicated + Onboarding',
    },
    // Pricing
    pricing: {
      title: 'Simple and transparent pricing',
      subtitle: 'Choose the plan that fits your needs',
      monthly: 'Monthly',
      sixMonths: '6 Months',
      annual: 'Annual',
      starter: 'Starter',
      pro: 'Pro',
      allInOne: 'All-in-one',
      perMonth: '/month',
      perSixMonths: '/6 months',
      perYear: '/year',
      popular: 'Popular',
      bestValue: 'Best value',
      save: 'Save',
      subscribe: 'Subscribe',
      features: {
        unlimitedInvoices: 'Unlimited invoices',
        unlimitedQuotes: 'Unlimited quotes',
        unlimitedClients: 'Unlimited clients',
        pdfTemplates: '20 PDF templates',
        qrBill: 'Swiss QR-bill',
        emailSupport: 'Email support',
        multiCurrency: 'Multi-currency (CHF/EUR/USD)',
        csvImport: 'CSV client import',
        prioritySupport: 'Priority support',
        multiUser: 'Multi-user (team)',
        accountingExport: 'Accounting export Bexio/Crésus',
        prioritySupport24: '24h priority support',
        unlimitedInvoicesQuotes: 'Unlimited invoices & quotes',
        pdfTemplates20: '20 professional PDF templates',
        qrBillSwiss: 'Swiss QR-Bill (SIX compliant)',
        allStarter: 'Everything in Starter +',
        hrPayroll: 'Swiss HR & Payroll',
        shopifySync: 'Shopify synchronization',
        allPro: 'Everything in Pro +',
        annualSaving: 'Save 159 CHF/year',
        aiAssistant: 'Integrated AI assistant',
        stockManagement: 'Stock Management & Inventory',
        clientPortal: 'Client Portal with payment',
        mobileApp: 'Mobile App (PWA)',
        dedicatedSupport: 'Dedicated support & onboarding',
      }
    },
    // Common
    common: {
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      download: 'Download',
      preview: 'Preview',
      send: 'Send',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      yes: 'Yes',
      no: 'No',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      close: 'Close',
      add: 'Add',
      actions: 'Actions',
      status: 'Status',
      date: 'Date',
      amount: 'Amount',
      total: 'Total',
      subtotal: 'Subtotal',
      tax: 'VAT',
      noData: 'No data',
      all: 'All',
      print: 'Print',
      duplicate: 'Duplicate',
      view: 'View',
      details: 'Details',
    },
    // Auth
    auth: {
      email: 'Email',
      password: 'Password',
      companyName: 'Company name',
      login: 'Log in',
      register: 'Sign up',
      forgotPassword: 'Forgot password?',
      noAccount: 'Don\'t have an account?',
      hasAccount: 'Already have an account?',
      createAccount: 'Create account',
      loginHere: 'Log in here',
      welcome: 'Welcome',
      welcomeBack: 'Welcome back',
      loginSubtitle: 'Sign in to your account',
      registerSubtitle: 'Create your account in seconds',
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      totalRevenue: 'Total Revenue',
      pendingAmount: 'Pending',
      invoicesCount: 'Invoices',
      clientsCount: 'Clients',
      recentInvoices: 'Recent Invoices',
      newInvoice: 'New Invoice',
      newQuote: 'New Quote',
      viewAll: 'View all',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      thisYear: 'This year',
      growth: 'Growth',
      quickActions: 'Quick actions',
      overdueInvoices: 'Overdue invoices',
      paidThisMonth: 'Paid this month',
    },
    // Invoices
    invoices: {
      title: 'Invoices',
      create: 'New Invoice',
      number: 'Invoice #',
      client: 'Client',
      date: 'Date',
      dueDate: 'Due date',
      status: 'Status',
      amount: 'Amount',
      actions: 'Actions',
      paid: 'Paid',
      sent: 'Sent',
      draft: 'Draft',
      overdue: 'Overdue',
      cancelled: 'Cancelled',
      markAsPaid: 'Mark as paid',
      markAsSent: 'Mark as sent',
      downloadPdf: 'Download PDF',
      sendByEmail: 'Send by email',
      deleteConfirm: 'Delete this invoice?',
      deleteWarning: 'This action cannot be undone.',
      noInvoices: 'No invoices',
      createFirst: 'Create your first invoice',
      searchPlaceholder: 'Search invoice...',
      filterByStatus: 'Filter by status',
      exportCsv: 'Export CSV',
      viewQr: 'View QR-bill',
      partialPayment: 'Partial payment',
      remainingAmount: 'Remaining amount',
      paymentHistory: 'Payment history',
    },
    // Quotes
    quotes: {
      title: 'Quotes',
      create: 'New Quote',
      number: 'Quote #',
      client: 'Client',
      date: 'Date',
      validUntil: 'Valid until',
      status: 'Status',
      amount: 'Amount',
      accepted: 'Accepted',
      pending: 'Pending',
      rejected: 'Rejected',
      expired: 'Expired',
      convertToInvoice: 'Convert to invoice',
      noQuotes: 'No quotes',
      createFirst: 'Create your first quote',
    },
    // Clients
    clients: {
      title: 'Clients',
      create: 'New Client',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      city: 'City',
      postalCode: 'Postal code',
      country: 'Country',
      totalBilled: 'Total billed',
      totalPaid: 'Total paid',
      balance: 'Balance',
      noClients: 'No clients',
      createFirst: 'Add your first client',
      importCsv: 'Import CSV',
      clientDetails: 'Client details',
      invoiceHistory: 'Invoice history',
    },
    // Settings
    settings: {
      title: 'Settings',
      companyInfo: 'Company information',
      companyName: 'Company name',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      website: 'Website',
      logo: 'Logo',
      uploadLogo: 'Upload logo',
      invoiceSettings: 'Invoice settings',
      defaultPaymentTerms: 'Payment terms',
      defaultNotes: 'Default notes',
      vatSettings: 'VAT settings',
      vatNumber: 'VAT number',
      vatRate: 'VAT rate',
      vatExempt: 'VAT exempt',
      commerceRegister: 'Commercial register',
      iban: 'IBAN',
      qrBillSettings: 'QR-bill settings',
      pdfTemplate: 'PDF template',
      templateColor: 'Template color',
      smtpSettings: 'Email settings (SMTP)',
      smtpHost: 'SMTP server',
      smtpPort: 'Port',
      smtpUser: 'User',
      smtpPassword: 'Password',
      saved: 'Settings saved',
      currency: 'Currency',
      language: 'Language',
    },
    // Team
    team: {
      title: 'Team Management',
      invite: 'Invite member',
      role: 'Role',
      admin: 'Administrator',
      accountant: 'Accountant',
      reader: 'Reader',
      pending: 'Pending',
      active: 'Active',
      remove: 'Remove',
      noMembers: 'No members',
      inviteSent: 'Invitation sent',
    },
    // Sidebar
    sidebar: {
      invoiceManagement: 'Swiss ERP for SMEs',
      newInvoice: 'New invoice',
      newQuote: 'New quote',
      freeTrial: 'Free trial',
      invoicesLeft: 'invoices',
      quotesLeft: 'quotes left',
      viewPlans: 'View plans',
      accountExpired: 'Account expired',
      activateSubscription: 'Activate your subscription to continue.',
      subscribeNow: 'Subscribe now',
      activeSubscription: 'Active subscription',
      expiresOn: 'Expires on',
      administrator: 'Administrator',
    },
    // Fiscal
    fiscal: {
      title: 'Fiscal Report',
      year: 'Year',
      revenue: 'Revenue',
      expenses: 'Expenses',
      profit: 'Net profit',
      taxDue: 'VAT due',
      downloadReport: 'Download report',
      quarterly: 'Quarterly',
      monthly: 'Monthly',
      annual: 'Annual',
    },
    // Expenses
    expenses: {
      title: 'Expenses',
      create: 'New expense',
      category: 'Category',
      description: 'Description',
      receipt: 'Receipt',
      noExpenses: 'No expenses',
    },
    // Shopify
    shopify: {
      title: 'Shopify Integration',
      connect: 'Connect Shopify',
      disconnect: 'Disconnect',
      shopUrl: 'Shop URL',
      accessToken: 'Access token',
      syncOrders: 'Sync orders',
      lastSync: 'Last sync',
      autoSync: 'Auto sync',
      orders: 'Orders',
      createInvoice: 'Create invoice',
    },
    // Products
    products: {
      title: 'Products & Services',
      create: 'New product',
      name: 'Name',
      description: 'Description',
      price: 'Price',
      unit: 'Unit',
      noProducts: 'No products',
    },
    // Recurring
    recurring: {
      title: 'Recurring Invoices',
      create: 'New recurring',
      frequency: 'Frequency',
      nextDate: 'Next date',
      lastGenerated: 'Last generated',
      weekly: 'Weekly',
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      yearly: 'Yearly',
      active: 'Active',
      paused: 'Paused',
    },
    hr: {
      employees: 'Employees',
      payslips: 'Payslips',
      employeesCount: 'employee(s)',
      addEmployee: 'Add employee',
      searchEmployees: 'Search employees...',
      noEmployees: 'No employees',
      addFirstEmployee: 'Add your first employee to get started',
      name: 'Name',
      position: 'Position',
      contract: 'Contract',
      salary: 'Salary',
      workRate: 'Work rate',
      newEmployee: 'New employee',
      editEmployee: 'Edit employee',
      personalInfo: 'Personal information',
      firstName: 'First name',
      lastName: 'Last name',
      dateOfBirth: 'Date of birth',
      email: 'Email',
      phone: 'Phone',
      civilStatus: 'Civil status',
      single: 'Single',
      married: 'Married',
      divorced: 'Divorced',
      widowed: 'Widowed',
      children: 'Number of children',
      nationality: 'Nationality',
      permitType: 'Permit type',
      address: 'Address',
      street: 'Street',
      postalCode: 'Postal code',
      city: 'City',
      canton: 'Canton',
      employment: 'Employment',
      department: 'Department',
      contractType: 'Contract type',
      startDate: 'Start date',
      avsNumber: 'AVS number',
      salaryInfo: 'Salary',
      grossSalary: 'Gross monthly salary (CHF)',
      has13thMonth: '13th month salary',
      lppEnrolled: 'LPP enrolled',
      iban: 'IBAN',
      bankName: 'Bank name',
      mealAllowance: 'Meal allowance',
      transportAllowance: 'Transport allowance',
      otherAllowances: 'Other allowances',
      employeeCreated: 'Employee created successfully',
      employeeUpdated: 'Employee updated',
      employeeDeleted: 'Employee deleted',
      confirmDelete: 'Are you sure you want to delete this employee?',
      viewPayslips: 'View payslips',
      newPayslip: 'New payslip',
      noPayslips: 'No payslips',
      createFirstPayslip: 'Create your first payslip',
      addEmployeesFirst: 'Add employees first',
      selectEmployee: 'Select employee',
      employee: 'Employee',
      month: 'Month',
      year: 'Year',
      workedDays: 'Worked days',
      overtimeHours: 'Overtime hours',
      bonus: 'Bonus',
      otherDeductions: 'Other deductions',
      notes: 'Notes',
      notesPlaceholder: 'Optional notes...',
      calculate: 'Calculate',
      payslipPreview: 'Payslip preview',
      earnings: 'Earnings',
      baseSalary: 'Base salary',
      '13thMonth': '13th month',
      allowances: 'Allowances',
      overtimePay: 'Overtime',
      totalGross: 'Total gross',
      deductions: 'Deductions',
      totalDeductions: 'Total deductions',
      netSalary: 'Net salary',
      createPayslip: 'Create payslip',
      payslipCreated: 'Payslip created',
      payslipValidated: 'Payslip validated',
      period: 'Period',
      gross: 'Gross',
      net: 'Net',
      status: 'Status',
      totalNet: 'Net total',
      payslipsCount: 'Payslips',
      salaryCertificate: 'Salary certificate',
      certificateDownloaded: 'Certificate downloaded',
      certificateError: 'Error: No validated payslips found',
      absencesPlanning: 'Planning & Absences',
      newAbsence: 'New absence',
      noAbsences: 'No absences',
      noAbsencesThisMonth: 'No absence requests this month',
      absenceType: 'Absence type',
      endDate: 'End date',
      reason: 'Reason',
      reasonPlaceholder: 'Optional reason...',
      submitRequest: 'Submit request',
      absenceCreated: 'Absence request created',
      absenceApproved: 'Absence approved',
      absenceRejected: 'Absence rejected',
      pendingRequests: 'Pending',
      approved: 'Approved',
      totalAbsenceDays: 'Absence days',
      publicHolidays: 'Public holidays',
      publicHolidaysIn: 'Public holidays in',
      days: 'Days',
      type: 'Type',
      fillRequired: 'Please fill all required fields',
      accountingEntries: 'Accounting entries',
      journalEntries: 'Journal entries',
      exportCSV: 'Export CSV',
      exportSuccess: 'Export successful',
      noEntries: 'No entries',
      noValidatedPayslips: 'No validated payslips for this period',
      entriesBalanced: 'Entries balanced',
      entriesUnbalanced: 'Entries unbalanced',
      grossSalaries: 'Gross salaries',
      employerCharges: 'Employer charges',
      totalCost: 'Total cost',
      netSalaries: 'Net salaries',
      account: 'Account',
      accountName: 'Account name',
      description: 'Description',
      debit: 'Debit',
      credit: 'Credit',
      totals: 'TOTALS',
      accountLegend: 'Chart of accounts used',
      date: 'Date',
      dashboard: 'HR Dashboard',
      dashboardSubtitle: 'Human resources overview',
      totalEmployees: 'Employees',
      monthlyPayroll: 'Monthly payroll',
      avgSalary: 'Average salary',
      pendingAbsences: 'Pending absences',
      ytdSummary: 'Year-to-date summary',
      contractTypes: 'Contract types',
      quickActions: 'Quick actions',
      alertsReminders: 'Alerts & Reminders',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first
    const saved = localStorage.getItem('language');
    if (saved && ['fr', 'de', 'en'].includes(saved)) return saved;
    
    // Then browser language
    const browserLang = navigator.language.split('-')[0];
    if (['fr', 'de', 'en'].includes(browserLang)) return browserLang;
    
    // Default to French
    return 'fr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback to French
        value = translations['fr'];
        for (const fk of keys) {
          if (value && value[fk]) {
            value = value[fk];
          } else {
            return key; // Return key if not found
          }
        }
        break;
      }
    }
    
    return value;
  };

  const languages = [
    { code: 'fr', name: 'Français', flag: '🇨🇭' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
  ];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
;
